	export enum SchedulingClaimFrequencyEnum {
		Weekly = 1,
		Monthly = 2
	}
